import React, { PropTypes, Component } from 'react'
import {withRouter} from 'react-router-dom';
import style from './style.css';

class SectionTitle extends Component {

    render() {
        return (
            <h2 className={ style.title }>{ this.props.title } { this.props.subtitle && <span onClick={() => { this.props.history.push(this.props.link)}} className={ style.subtitle }>{this.props.subtitle}</span>}</h2>
        )
    }
}

export default withRouter(SectionTitle)



// WEBPACK FOOTER //
// ./src/components/resorthome/sectiontitle/index.js